(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gtCookieConsent) return;
    window.__gtCookieConsent = true;

    var STORAGE_KEY = 'gt_consent';
    var banner = document.querySelector('[data-cookie-consent]');
    if (!banner) return;

    function readStored() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function persist(status) {
      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ status: status, ts: Date.now() })
        );
      } catch (e) {}
    }

    function dismiss(status) {
      persist(status);
      banner.classList.remove('is-visible');
      banner.classList.add('is-leaving');
      var onEnd = function () {
        banner.setAttribute('hidden', '');
        banner.classList.remove('is-leaving');
        banner.removeEventListener('transitionend', onEnd);
      };
      banner.addEventListener('transitionend', onEnd);
      setTimeout(onEnd, 700);

      document.dispatchEvent(
        new CustomEvent('gt:consent', { detail: { status: status } })
      );
    }

    function show() {
      banner.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          banner.classList.add('is-visible');
        });
      });
    }

    if (readStored()) return;

    banner.querySelector('[data-consent-accept]').addEventListener('click', function () {
      dismiss('accepted');
    });
    banner.querySelector('[data-consent-reject]').addEventListener('click', function () {
      dismiss('essential');
    });

    setTimeout(show, 600);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["launch-promo"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gtLaunchPromo) return;
    window.__gtLaunchPromo = true;

    var SESSION_KEY = 'gt_promo_launch_session';
    var CONSENT_KEY = 'gt_consent';
    var SHOW_DELAY_AFTER_CONSENT = 900;
    var SHOW_DELAY_ON_RETURN = 1600;

    var promo = document.querySelector('[data-launch-promo]');
    if (!promo) return;

    function readLocal(key) {
      try { return localStorage.getItem(key); } catch (e) { return null; }
    }
    function readSession(key) {
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    }
    function persistSession(key, value) {
      try { sessionStorage.setItem(key, value); } catch (e) {}
    }

    if (readSession(SESSION_KEY)) return;

    var dismissed = false;

    function show() {
      if (dismissed) return;
      promo.removeAttribute('hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          promo.classList.add('is-visible');
        });
      });
    }

    function hide(persist) {
      if (dismissed) return;
      dismissed = true;
      if (persist !== false) persistSession(SESSION_KEY, '1');
      promo.classList.remove('is-visible');
      promo.classList.add('is-leaving');
      var onEnd = function () {
        promo.setAttribute('hidden', '');
        promo.classList.remove('is-leaving');
        promo.removeEventListener('transitionend', onEnd);
      };
      promo.addEventListener('transitionend', onEnd);
      setTimeout(onEnd, 500);
    }

    promo.querySelectorAll('[data-launch-close]').forEach(function (el) {
      el.addEventListener('click', function () { hide(); });
    });

    var signupBtn = promo.querySelector('[data-launch-signup]');
    if (signupBtn) {
      signupBtn.addEventListener('click', function () {
        hide();
        // Delegate modal opening to the header which owns the register modal
        // state + body.overflow management. Small delay so the badge's fade
        // doesn't overlap the modal's entrance animation.
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('gt:open-register'));
        }, 260);
      });
    }

    if (readLocal(CONSENT_KEY)) {
      setTimeout(show, SHOW_DELAY_ON_RETURN);
    } else {
      document.addEventListener('gt:consent', function () {
        setTimeout(show, SHOW_DELAY_AFTER_CONSENT);
      }, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["policy-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gtPolicyModal) return;
    window.__gtPolicyModal = true;

    var modal = document.querySelector('[data-policy-modal]');
    if (!modal) return;
    var titleEl = modal.querySelector('[data-policy-title]');
    var bodyEl = modal.querySelector('[data-policy-body]');
    var I18N = window.GT_PAGE_I18N || { policyTitles: {}, policyDefault: '' };
    var TITLES = I18N.policyTitles;

    function open(key) {
      var tpl = document.querySelector('template[data-policy-content="' + key + '"]');
      if (!tpl) return;
      titleEl.textContent = TITLES[key] || I18N.policyDefault;
      bodyEl.innerHTML = '';
      bodyEl.appendChild(tpl.content.cloneNode(true));
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('policy-lock');
      // Reset scroll AFTER the modal is visible (scrollTop is ignored while the
      // element is display:none), so every open starts at the top.
      var card = modal.querySelector('.policy-modal__card');
      requestAnimationFrame(function () {
        bodyEl.scrollTop = 0;
        if (card) card.scrollTop = 0;
      });
    }

    function close() {
      modal.classList.add('is-closing');
      setTimeout(function () {
        modal.hidden = true;
        modal.classList.remove('is-closing');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('policy-lock');
        bodyEl.innerHTML = '';
      }, 200);
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-policy]');
      if (opener) {
        e.preventDefault();
        open(opener.dataset.policy);
        return;
      }
      if (e.target.closest('[data-policy-close]')) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
